(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-grid"] && !Shopify.designMode) return;
  try {
    
  class VariantGrid extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.variant-grid__item'));
      this.chips = Array.from(this.querySelectorAll('.variant-grid__chip'));
      this.clearButton = this.querySelector('.variant-grid__clear');
      this.noResults = this.querySelector('.variant-grid__no-results');

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const pressed = chip.getAttribute('aria-pressed') === 'true';
          chip.setAttribute('aria-pressed', pressed ? 'false' : 'true');
          this.apply();
        });
      });

      this.clearButton?.addEventListener('click', () => {
        this.chips.forEach((chip) => chip.setAttribute('aria-pressed', 'false'));
        this.apply();
      });
    }

    // A tile survives when every group that has a selection matches it. Groups
    // with nothing selected don't narrow anything.
    apply() {
      const selected = new Map();

      this.chips.forEach((chip) => {
        if (chip.getAttribute('aria-pressed') !== 'true') return;
        const group = chip.closest('[data-filter-group]').dataset.filterGroup;
        if (!selected.has(group)) selected.set(group, new Set());
        selected.get(group).add(chip.dataset.filterValue);
      });

      let visible = 0;

      this.items.forEach((item) => {
        const matches = Array.from(selected).every(([group, values]) =>
          values.has(item.dataset[group])
        );
        item.hidden = !matches;
        if (matches) visible += 1;
      });

      if (this.clearButton) this.clearButton.hidden = selected.size === 0;
      if (this.noResults) this.noResults.hidden = visible > 0;
    }
  }

  if (!customElements.get('variant-grid')) {
    customElements.define('variant-grid', VariantGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
